import { css } from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const disableTextSelection = css`
  -moz-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
`;
